import { render, staticRenderFns } from "./PersonnelList.vue?vue&type=template&id=0835efc6&"
import script from "./PersonnelList.vue?vue&type=script&lang=js&"
export * from "./PersonnelList.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelList.vue?vue&type=style&index=0&id=0835efc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports